import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'month'
})

export class MonthPipe implements PipeTransform {
    transform(value: string, format: string = ""): string {        
        if (!value || value==="") return "";
        value=value+"/01";
        return moment(new Date(value), 'YYYY/mm/dd').format(format);
        //return moment(new Date(value), 'YYYY/mm/dd').format('MMMM');
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/month.pipe.ts